<script>
import { mapState, mapActions } from "vuex";
import { VueGoodTable } from "vue-good-table";
import APIService from "@/services/api.service";
import { id } from "vuejs-datepicker/dist/locale";
import Datepicker from "vuejs-datepicker";
import axios from "axios";
import config from "@/data/config";
import { SweetModal } from "sweet-modal-vue";
import VueNumeric from 'vue-numeric'
import cryptoRandomString from "crypto-random-string";

export default {
   name: "Iuran",
   components: {
      VueGoodTable,
      SweetModal,
      Datepicker,
      VueNumeric
   },
   data() {
      return {
         info: {},
         loading: true,
         PDFloading: false,
         frameLoading: false,
         baseURL: config.baseURL,
         windowHeight: window.innerHeight - 250,
         fileURL: "",
         filterDateLang: id,
         lingkunganStasi_: [],
         myData: {
            tanggal: this.$moment(new Date()).format("YYYY-MM-DD"),
            ket: "",
            jumlah: 0
         },
         item: {
            id: "",
            uid: "",
            nomor: "",
            nama_kepala: "",
            anggota: "",
            alamat: "",
         },
         dataIuran: [],
         columns: [
            {
               label: "Nomor",
               field: "nomor",
               sortable: false,
            },
            {
               label: "Kepala Keluarga",
               field: this.namaFn,
               sortable: false,
               thClass: "text-center",
               html: true
            },
            {
               label: "Anggota",
               field: "total_anggota",
               sortable: false,
               thClass: "text-center",
               tdClass: "text-center",
            },
            {
               label: "Alamat",
               field: "alamat",
               sortable: false,
               thClass: "text-center",
            },
            {
               label: "Jumlah",
               field: this.jumlahFn,
               sortable: false,
               thClass: "text-right",
               tdClass: "text-right",
            },
         ],
         rows: [],
         totalRecords: 0,
         serverParams: {
            tahun: new Date(),
            lingkungan_stasi: "AGUSTINUS",
         },
         totalIuran: 0,
         totalKk: 0
      };
   },
   mounted() {
      this.loadItems();
      this.lingkunganStasi_ = [...this.lingkunganStasi];
      this.lingkunganStasi_.unshift("-");
   },
   computed: {
      isLoading() {
         return this.$store.state.isLoading;
      },
      ...mapState({
         auth: (state) => state.auth.user,
         lingkunganStasi: (state) => state.service.lingkunganStasi,
         // rows: (state) => state.keluargaKatolik.data,
         // totalRecords: (state) => state.keluargaKatolik.totalRecords,
      }),
   },
   watch: {
      PDFloading: function (val) {
         if (val) {
            this.$swal({ text: "Loading", allowOutsideClick: false });
            this.$swal.showLoading();
         } else {
            this.$swal.close();
         }
      },
   },
   methods: {
      ...mapActions({
         getAll: "iuran/getAllRemote",
         insert: "iuran/insert",
         delete: "iuran/delete",
      }),
      namaFn(row) {
         return row.kepala_keluarga ? "<span>" + row.kepala_keluarga + "</span>" : "<span class='text-danger'>" + row.nama_kepala + "</span>";
      },
      jumlahFn(row) {
         return this.$options.filters.formatNumber(row.total_iuran);
      },
      refreshData() {
         this.$refs["goodTable"].reset();
         this.loadItems();
      },
      onChangeJenis() {
         this.loadItems();
      },
      swalConfirm(id) {
         this.$swal({
            title: "Apakah anda yakin?",
            text: "Data tidak dapat dipulihkan kembali!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Ya, Hapus!",
            html: false,
            allowOutsideClick: false,
            preConfirm: () => {
               return this.delete(id).then(
                  (response) => {
                     return Promise.resolve(response.data);
                  },
                  (error) => {
                     this.$swal("Gagal!", "", "danger");
                     return Promise.reject(error);
                  }
               );
            },
         }).then((result) => {
            if (typeof result.value !== "undefined") {
               if (result.value) {
                  this.loadItems();
                  this.$bvModal.hide("modal-action");
                  this.$swal("Deleted!", result.value.message, "success");
               } else {
                  this.$swal("Gagal!", result.value, "danger");
               }
            }
         });
      },
      showPDFKK() {
         console.log("START");
         this.PDFloading = true;
         this.frameLoading = true;
         this.fileURL = this.baseURL + "assets/_blank.pdf";
         axios
            .post(APIService.getPDFLaporanIuran(), this.serverParams, {
               headers: APIService.getHeader(),
            })
            .then(
               (response) => {
                  const timestamp = this.$moment().toDate().getTime()

                  this.fileURL =
                     this.baseURL + "pdf/" + response.data.filename + ".pdf?v=" + timestamp;
                  this.$refs.modalfile.open();
                  this.PDFloading = false;
                  console.log("FINISH");
               },
               () => {
                  // this.PDFloading = false;
               }
            );
      },
      load() {
         this.frameLoading = false;
         console.log("FINISH LOAD");
      },

      // --------------------
      // ---- GOOD TABLE ----
      // --------------------
      async loadItems() {
         this.loading = true;
         await this.getAll(this.serverParams).then((response) => {
            // console.log(response);
            this.rows = response.rows;
            this.totalRecords = response.rows.length;
            this.totalIuran = response.total;
            this.totalKk = response.total_kk;
         });
      },
      onRowClick(params) {
         this.item.uid = params.row.uid;
         this.item.uid_iuran = params.row.uid_iuran;
         this.item.lingkungan = params.row.lingkungan_stasi;
         this.item.nama_kepala = params.row.nama_kepala;

         this.item.total_iuran = params.row.total_iuran;

         this.dataIuran = params.row.iuran_item

         this.$bvModal.show("modal-action");
      },

      onTambahIuran() {
         if (this.item.uid_iuran) {
            this.myData.uid = this.item.uid_iuran;
         } else {
            this.myData.uid = cryptoRandomString({
               length: 32,
               type: "distinguishable",
            });
         }

         this.myData.ket = ""
         this.myData.jumlah = 0
         this.myData.tahun = this.$moment(this.serverParams.tahun).format("YYYY")
         this.myData.lingkungan = this.item.lingkungan
         this.myData.kk_uid = this.item.uid

         this.$bvModal.show("modal-form");
      },
      onSubmit() {
         this.insert(this.myData).then(async () => {
            await this.loadItems()
            this.$bvModal.hide("modal-form");
            this.$bvModal.hide("modal-action");
         });
      },
   },
};
</script>

<template>
   <div>
      <Breadcrumbs title="Data Iuran KK" />
      <!-- Container-fluid starts-->
      <div class="container-fluid">
         <div class="card">
            <div class="card-header">
               <div class="row">
                  <div class="col-sm-6 create-project-btn">
                     <div class="ml-3">
                        Total Tahun {{ $moment(serverParams.tahun).format("YYYY") }} Lingkungan : {{
                           serverParams.lingkungan_stasi }}
                        <h4 class="text-primary mt-1 mb-1"> {{ totalIuran | formatNumber }}</h4>
                        <small>dari {{ totalKk | formatNumber }} kk</small>
                     </div>
                  </div>
                  <div class="col-sm-6 create-project-btn">
                     <div class="text-right">
                        <b-button-group class="btn-group-pill">
                           <b-button variant="primary" size="sm" @click="showPDFKK()" v-b-tooltip.hover title="PDF"><i
                                 class="fa fa-file-pdf-o"></i></b-button>
                           <b-button v-b-toggle.collapse-filter variant="primary" size="sm" v-b-tooltip.hover
                              title="Filter"><i class="fa fa-filter"></i></b-button>
                           <b-button variant="primary" size="sm" @click="refreshData()" v-b-tooltip.hover title="Refresh">
                              <div v-show="isLoading" class="
                                                spinner-border spinner-border-sm
                                                text-light
                                             " role="status" aria-hidden="true"></div>
                              <i class="fa fa-refresh" v-show="!isLoading"></i>
                           </b-button>
                        </b-button-group>
                     </div>
                  </div>
               </div>
            </div>

            <!-- --------------------------- /FILTER --------------------------- -->

            <b-collapse id="collapse-filter" class="mt-2" visible>
               <div class="card-body pb-1 pt-1">
                  <div class="row">
                     <div class="col-md-6">
                        <div class="form-group">
                           <label>Lingkungan/Stasi Umat</label>
                           <b-form-select name="lingkungan_stasi" v-model="serverParams.lingkungan_stasi"
                              :options="lingkunganStasi_" @input="onChangeJenis($event)" size="sm"></b-form-select>
                        </div>
                     </div>
                     <div class="col-md-6">
                        <div class="form-group">
                           <label>Tahun baptis</label>
                           <datepicker v-model="serverParams.tahun"
                              input-class="datepicker-here form-control form-control-sm" :minimumView="'year'"
                              :maximumView="'year'" format="yyyy" :language="filterDateLang" @input="onChangeJenis($event)"
                              required></datepicker>
                        </div>
                     </div>

                  </div>
                  <hr />
               </div>
            </b-collapse>

            <div class="card-body">
               <vue-good-table ref="goodTable" @on-row-click="onRowClick" :totalRows="totalRecords"
                  :isLoading.sync="loading" :pagination-options="{
                     enabled: false,
                  }" :rows="rows" :columns="columns" :search-options="{
   enabled: true,
}" :line-numbers="true" />
            </div>
         </div>
      </div>

      <b-modal id="modal-action" centered :title="`${item.nama_kepala}`" size="lg" hide-footer>
         <div class="card">
            <div class="card-body p-1">
               <div class="row">
                  <div class="col-sm-6 create-project-btn">Total : <h5 class="text-primary">{{ item.total_iuran |
                     formatNumber }}</h5>
                  </div>
                  <div class="col-sm-6 create-project-btn" v-if="this.auth.group_id != '3'">
                     <div class="text-right">
                        <b-button pill variant="primary" size="sm" v-b-tooltip.hover title="Tambah"
                           @click="onTambahIuran"><i class="fa fa-plus"></i> Tambah</b-button>
                     </div>
                  </div>
               </div>
               <hr>
               <v-table class="
                                 table
                                 b-table
                                 table-vcenter table-striped table-bordered table-hover
                              " :data="dataIuran" :pageSize="20">
                  <thead slot="head" class="thead-light">
                     <v-th sortKey="tanggal" defaultSort="desc" class="text-left">Tanggal</v-th>
                     <th class="text-left">Ket</th>
                     <v-th sortKey="jumlah" defaultSort="desc" class="text-right">Jumlah</v-th>
                     <th class="text-center">Action</th>
                  </thead>
                  <tbody slot="body" slot-scope="{ displayData }">
                     <tr v-for="item in displayData" :key="item.id">
                        <td>{{ $moment(item.tanggal).format("DD MMMM YYYY") }}</td>
                        <td>{{ item.ket }}</td>
                        <td class="text-right">{{ item.jumlah | formatNumber }}</td>
                        <td class="text-center">
                           <b-button pill size="sm" variant="danger" v-b-tooltip.hover title="Delete"
                              @click="swalConfirm(item.id)">
                              <i class="fa fa-times"></i>
                           </b-button>
                        </td>
                     </tr>

                     <tr v-if="!displayData.length">
                        <td colspan="100">
                           <p class="text-center p-2">Belum ada Iuran</p>
                        </td>
                     </tr>
                  </tbody>
               </v-table>
            </div>
         </div>
      </b-modal>

      <b-modal id="modal-form" hide-footer size="lg" title="Form Iuran KK">
         <div class="card shadow">
            <div class="card-body p-1">
               <div class="container-fluid">
                  <form @submit.prevent="onSubmit" id="form-data">
                     <div class="form theme-form">
                        <div class="row">
                           <div class="col-md-6">
                              <div class="form-group">
                                 <label>Tanggal<span class="text-danger">*</span></label>
                                 <b-form-datepicker name="tanggal" size="sm" v-model="myData.tanggal" placeholder="Tanggal"
                                    locale="id" required></b-form-datepicker>

                              </div>
                              <div class="form-group">
                                 <label>Jumlah : Rp. {{ myData.jumlah | formatNumber }}</label>
                                 <vue-numeric class="form-control" currency="Rp" separator="." v-model="myData.jumlah"
                                    required></vue-numeric>
                              </div>
                           </div>
                           <div class="col-md-6">
                              <div class="form-group">
                                 <label>Tahun</label>
                                 <input v-model="myData.tahun" name="tahun" class="form-control" type="text" disabled />
                              </div>
                              <div class="form-group">
                                 <label>Keterangan</label>
                                 <input v-model="myData.ket" name="ket" class="form-control" type="text" />
                              </div>
                           </div>
                        </div>
                        <hr />
                        <div class="row">
                           <div class="col">
                              <div class="form-group mb-0">
                                 <b-button class="mr-3" type="submit" variant="primary" :disabled="isLoading"
                                    form="form-data">
                                    <span v-show="isLoading" class="
                                             spinner-border spinner-border-sm
                                          "></span><i class="fa fa-fw fa-save" v-show="!isLoading"></i>
                                    Simpan
                                 </b-button>
                              </div>
                           </div>
                        </div>
                     </div>
                  </form>
               </div>
            </div>
         </div>
      </b-modal>

      <sweet-modal modal-theme="light" overlay-theme="dark" width="80%" ref="modalfile">
         <div class="loader-box" v-show="frameLoading">
            <div class="loader-2"></div>
         </div>
         <iframe v-show="!frameLoading" width="100%" :height="windowHeight" :src="fileURL" frameborder="0" allowfullscreen
            @load="load()"></iframe>
      </sweet-modal>
   </div>
</template>

<style scoped></style>